import React from 'react';
import { Zap, ShieldCheck, Clock, Plane, Leaf, DollarSign } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  zap: Zap,
  'shield-check': ShieldCheck,
  clock: Clock,
  plane: Plane,
  leaf: Leaf,
  'dollar-sign': DollarSign
};

const Features = () => {
  return (
    <section id="about" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why Choose <span className="text-amber-500">Executive EV</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Uncompromising excellence in every detail. Experience the difference of true luxury.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-8 rounded-xl bg-gradient-to-br from-slate-800 to-slate-800/50 border border-slate-700 hover:border-amber-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/10"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <div className="flex flex-col items-start">
                  <div className="w-12 h-12 rounded-lg bg-amber-500/10 flex items-center justify-center mb-4 group-hover:bg-amber-500/20 transition-colors">
                    <IconComponent className="w-6 h-6 text-amber-500" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-500 transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;